import React, { useState } from "react";
import { Checkbox, Typography } from "@mui/material";
import Plot from "react-plotly.js";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { Grid, Paper, TextField } from "@mui/material";

function Heatmap() {
  const [alltagname, setTagname] = React.useState([]);

  const [allcheckboxtagname, setChecboxtagname] = React.useState([]);
  const [allcorrdata, setAllCorrData] = React.useState([]);

  const [corrdata, setCorrData] = React.useState([]);
  const [checkedState, setCheckedState] = useState(new Array(50).fill(true));
  const [updatebox, setUpdateBox] = useState(false);
  const [strcorrdata, setstrCorrData] = React.useState([]);
  const [getLoader , setGetLoader] = React.useState(false);


  React.useEffect(() => {
    getAllTagName()
  }, []);


  const getAllTagName = () => { 
    const ProjectID = sessionStorage.getItem("projectID")
    setGetLoader(true)
    fetch(`${baseURL}/getalltagname?projectID=${ProjectID}`)
      .then((res) => res.json())
      .then((myresponse) => {
        setTagname(myresponse.tag_name);
        setCorrData(myresponse.rowlist);
        setstrCorrData(myresponse.corrdata);
        setChecboxtagname(myresponse.tag_name);
        setAllCorrData(myresponse.rowlist);
        setGetLoader(false)
      })
      .catch((err)=> {
        setGetLoader(false)
        console.log("error",err)})
   }


  const handleOnChange = (item, position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updatedCheckedState);
    if (alltagname.includes(item)) {
      setTagname(alltagname.filter((x, i) => x !== item));
      setCorrData(corrdata.filter((x, i) => x !== allcorrdata[position]));
    } 
    if(!alltagname.includes(item)) {
      let newData = allcorrdata[position]
      const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
      ]
      const result = insert(corrdata,position ,newData)
      setTagname(alltagname.splice(position, 0, item));
      setCorrData(result);
      setTagname(alltagname);
      
    }
    //setTagname(alltagname.filter((item,i)=>(item !== removeitem)))
    //setCorrData(corrdata.filter((item,i)=>(i !== position)))
  };

  const changeupdatebox = (alltagname,corrdata) =>{
    setUpdateBox(!updatebox);
    setTagname(alltagname);
    setCorrData(corrdata);
  }


return (
  <Box
    sx={{
      display: "flex",
      gap: 2,
      height: "100%",
      width: "100%",
    }}
  >
    {/* Left Filter Panel */}
    <Paper
      elevation={0}
      sx={{
        width: "25%",
        minWidth: "230px",
        height: "500px",
        borderRadius: "22px",
        overflow: "hidden",
        boxShadow: "0px 6px 20px rgba(0,0,0,.06)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#0078c9",
          color: "#fff",
          p: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          Variables
        </Typography>
      </Box>

      {/* Checkbox list */}
      <Box
        sx={{
          p: 1,
          overflowY: "auto",
          flex: 1,
        }}
      >
        {allcheckboxtagname?.map((item, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "12px",
              px: 1,
              py: .4,
              transition: ".2s",
              "&:hover": {
                bgcolor: "rgba(0,120,201,.05)",
              },
            }}
          >
            <Checkbox
              checked={checkedState[i]}
              value={item}
              onChange={() => handleOnChange(item, i)}
              sx={{
                color: "#0078c9",

                "&.Mui-checked": {
                  color: "#9e0b22",
                }
              }}
            />

            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>

    {/* Heatmap Card */}
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: "22px",
        p: 2,
        boxShadow: "0px 6px 20px rgba(0,0,0,.06)",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#0078c9",
          mb: 2,
        }}
      >
        Correlation Analysis
      </Typography>

      <Plot
        data={[
          {
            z: corrdata,
            x: alltagname,
            y: alltagname,
            type: "heatmap",

            colorscale: [
              [0, "#9e0b22"],
              [1, "#0078c9"],
            ],

            xgap: 2,
            ygap: 2,

            text: corrdata,
            texttemplate: "%{text:.2f}",
          },
        ]}
        layout={{
          autosize: true,

          margin: {
            l: 70,
            r: 20,
            t: 20,
            b: 80,
          },

          xaxis: {
            automargin: true,
          },

          yaxis: {
            automargin: true,
          },

          paper_bgcolor: "white",
          plot_bgcolor: "white",
        }}
        useResizeHandler={true}
        style={{
          width: "100%",
          height: "430px",
        }}
        config={{
          responsive: true,
          displaylogo: false,
        }}
      />
    </Paper>

    {getLoader && <GlobalLoader />}
  </Box>
);
}

export default Heatmap;
